// Mock data for the trademark website

export const testimonials = [
  {
    id: 1,
    name: "Rebecca Martinez",
    designation: "CEO & Founder",
    company: "TechFlow Solutions",
    text: "Outstanding service! They handled my trademark registration with precision and kept me informed throughout the entire process. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Brandon Sullivan",
    designation: "Restaurant Owner",
    company: "Urban Eats Co.",
    text: "Professional, efficient, and knowledgeable. My brand is now fully protected thanks to their expert guidance.",
    rating: 5
  },
  {
    id: 3,
    name: "Kimberly Washington",
    designation: "Wellness Coach",
    company: "Bloom Wellness",
    text: "The team made trademark registration simple and stress-free. Their attention to detail and customer service exceeded my expectations.",
    rating: 5
  },
  {
    id: 4,
    name: "Tyler Henderson",
    designation: "Marketing Director",
    company: "Apex Digital Marketing",
    text: "Fast, reliable, and affordable. They helped me secure my trademark without any hassles. Worth every penny!",
    rating: 5
  },
  {
    id: 5,
    name: "Patricia Lawson",
    designation: "Boutique Owner",
    company: "Luxe Fashion Boutique",
    text: "Exceptional experience from start to finish. Their expertise gave me confidence that my brand was in good hands.",
    rating: 5
  },
  {
    id: 6,
    name: "Michael Chen",
    designation: "Tech Entrepreneur",
    company: "InnovateTech Labs",
    text: "The comprehensive trademark search saved me from potential legal issues. Their team was thorough and professional throughout the entire process.",
    rating: 5
  },
  {
    id: 7,
    name: "Sarah Thompson",
    designation: "Creative Director",
    company: "Artisan Designs Studio",
    text: "I was impressed by their attention to detail and quick response times. They made the complex trademark process feel effortless.",
    rating: 5
  },
  {
    id: 8,
    name: "James Rodriguez",
    designation: "Business Consultant",
    company: "Strategic Growth Partners",
    text: "Highly professional team that delivered exactly what they promised. My clients now have peace of mind knowing their brands are protected.",
    rating: 5
  },
  {
    id: 9,
    name: "Emily Foster",
    designation: "E-commerce Manager",
    company: "Prime Retail Group",
    text: "Their Amazon Brand Registry assistance was invaluable. We've seen a significant reduction in counterfeit products since working with them.",
    rating: 5
  },
  {
    id: 10,
    name: "David Armstrong",
    designation: "Legal Advisor",
    company: "Armstrong & Associates",
    text: "As someone in the legal field, I appreciate their meticulous approach to trademark filings. They ensure every detail is perfect before submission.",
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Consultation & Search",
    description: "We review your brand details, assess trademark eligibility, and conduct comprehensive searches to identify potential conflicts and maximize your approval chances.",
    icon: "clipboard-check"
  },
  {
    id: 2,
    title: "Application & Filing",
    description: "We prepare and file your trademark application with accuracy, ensuring all documentation meets federal standards and requirements.",
    icon: "file-text"
  },
  {
    id: 3,
    title: "Monitoring & Registration",
    description: "Track your application status and receive ongoing support until your trademark is successfully registered and protected.",
    icon: "shield-check"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Basic",
    price: 45,
    popular: false,
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 2,
    name: "Deluxe",
    price: 145,
    popular: true,
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured",
      "Direct Hit Search",
      "Dedicated Case Manager"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 3,
    name: "Premium",
    price: 299,
    popular: false,
    features: [
      "Case Review (by a TM Expert)",
      "Basic Free Trademark Search",
      "Trademark Monitoring Services (3 Months)",
      "Trademark Secured",
      "Refusal Risk Meter",
      "Case filing service with complete paperwork"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 4,
    name: "Elite",
    price: 599,
    popular: false,
    features: [
      "Case Review & Filing (U.S. Registered IP Attorney)",
      "Assigned Case Filing Officer",
      "Private Registration",
      "Trademark Secured",
      "Federal Search & Clearance Report (All States)",
      "Federal E-Filing (USPTO)",
      "Cease & Desist Letter",
      "Same Day Filing",
      "Trademark Monitoring (1 Year)",
      "Direct Hit Search",
      "Dedicated Case Manager",
      "24/7 Secure Online Access",
      "100% Approval Guarantee"
    ],
    note: "Govt. filing fee not included"
  }
];

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    description: "Secure your brand identity with comprehensive trademark protection that safeguards your business name, logo, and intellectual property.",
    icon: "award",
    link: "/services/trademark-registration"
  },
  {
    id: 2,
    title: "Copyright Registration",
    description: "Protect your original creative works including writings, artwork, music, and digital content with official copyright registration.",
    icon: "file-badge",
    link: "/services/copyright-registration"
  },
  {
    id: 3,
    title: "Company Formation",
    description: "Launch your business with confidence through our streamlined company formation services including LLC, Corporation, and DBA registration.",
    icon: "building-2",
    link: "/services/company-formation"
  },
  {
    id: 4,
    title: "Trademark Search",
    description: "Avoid costly conflicts with our thorough trademark search services that identify potential obstacles before you file.",
    icon: "search-check",
    link: "/services/trademark-search"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    description: "Enhance your Amazon presence and protect your products from counterfeiters with our Amazon Brand Registry assistance.",
    icon: "shopping-bag",
    link: "/services/amazon-brand-registry"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does the trademark registration process take?",
    answer: "The complete trademark registration process typically takes 8-12 months from filing to registration. However, you'll receive a filing receipt within a few weeks, and your application will be examined within 3-4 months."
  },
  {
    id: 2,
    question: "What's the difference between state and federal trademark registration?",
    answer: "State registration protects your trademark only within that specific state, while federal registration through the USPTO provides nationwide protection and additional legal benefits, including the ability to use the ® symbol."
  },
  {
    id: 3,
    question: "Can I trademark a business name that's already in use?",
    answer: "It depends on several factors including the industry, geographic location, and likelihood of confusion. Our comprehensive search will help determine if your desired trademark is available and advise on the best course of action."
  },
  {
    id: 4,
    question: "What happens if my trademark application is rejected?",
    answer: "If your application receives an office action or rejection, we'll work with you to address the examiner's concerns through proper responses and amendments. Our higher-tier packages include dedicated support for handling office actions."
  },
  {
    id: 5,
    question: "Do I need to renew my trademark?",
    answer: "Yes, federal trademarks require maintenance filings. You'll need to file a Declaration of Use between the 5th and 6th year after registration, and renewal applications every 10 years to maintain your trademark rights."
  }
];

export const countryCodes = [
  { code: "+1", country: "US/Canada" },
  { code: "+44", country: "United Kingdom" },
  { code: "+61", country: "Australia" },
  { code: "+91", country: "India" },
  { code: "+86", country: "China" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+81", country: "Japan" },
  { code: "+82", country: "South Korea" }
];